import { ReactNode } from 'react'
import AddInstance from '../AddInstance'

interface TreeProps<T> {
  nodes: T[]
  depth?: number
  getKey: (node: T) => string
  getChildren: (node: T) => T[] | null | undefined
  renderNode: (node: T, depth: number) => ReactNode
  onAddChild: (parentKey: string | null) => void
}

function Tree<T>({
  nodes,
  depth = 0,
  getKey,
  getChildren,
  renderNode,
  onAddChild,
}: TreeProps<T>): ReactNode {
  if (nodes.length === 0) return <AddInstance onClick={() => onAddChild(null)} />

  return nodes.map(node => {
    const key = getKey(node)
    const children = getChildren(node)

    const row = (
      <div
        key={key}
        style={{ width: '100%', marginLeft: depth * 20 }}
      >
        {renderNode(node, depth)}
        <AddInstance onClick={() => onAddChild(key)} />
      </div>
    )

    return children?.length
      ? [
          row,
          <Tree
            key={key + '-children'}
            nodes={children}
            depth={depth + 1}
            getKey={getKey}
            getChildren={getChildren}
            renderNode={renderNode}
            onAddChild={onAddChild}
          />,
        ]
      : row
  })
}

export default Tree
